import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import './HiwStepItem.scss';
import HiwStepTitle from './HiwStepTitle';
import HiwStepContent from './HiwStepContent';

const HiwStepItem = ({
  stepNumber,
  titleKey,
  descriptionKey,
  bulletPoints = [],
  renderImage,
  cta = null
}) => {
  return (
    <div className="hiw-step-item">
      {renderImage({ className: 'hiw-step-item__image' })}
      <div className="hiw-step-item__content">
        <HiwStepTitle stepNumber={stepNumber} title={trans(titleKey)} />
        <HiwStepContent
          description={trans(descriptionKey)}
          bulletPoints={bulletPoints}
          cta={cta}
        />
      </div>
    </div>
  );
};

HiwStepItem.propTypes = {
  stepNumber: PropTypes.number.isRequired,
  titleKey: PropTypes.string.isRequired,
  descriptionKey: PropTypes.string.isRequired,
  bulletPoints: PropTypes.arrayOf(
    PropTypes.shape({
      titleKey: PropTypes.string.isRequired,
      textKey: PropTypes.string.isRequired
    })
  ),
  renderImage: PropTypes.func.isRequired,
  cta: PropTypes.shape({
    textKey: PropTypes.string.isRequired,
    routeId: PropTypes.string.isRequired
  })
};

export default HiwStepItem;
